import { getAPI, allAPI, getIMG, getOSS, getPREIMG } from './data.api.js';
import { auth } from './auth.js';
import request from 'superagent';
import moment from 'moment';
// import jsonp from 'superagent-jsonp'
import $ from 'jquery';
var util = {
  getAPI: function (arg) {
    return util.api(arg);
  },
  api: function (arg) {
    if (typeof arg == 'string') return getAPI(arg);
    if (typeof arg == 'object') {
      var apis = {};
      apis['OSS'] = getOSS('');
      apis['IMG'] = getIMG('');
      apis['PRE'] = getPREIMG('');
      for (var i in arg) {
        apis[arg[i]] = getAPI(arg[i]);
      }
      return apis;
    }
  },
  apis: function () {
    return allAPI();
  },
  imgPath: function (path) {
    return getIMG(path);
  },
  preImgPath: function (path) {
    return getPREIMG(path);
  },
  getOSS: function () {
    return getOSS();
  },
  /**
   * 向前
   */
  back: function () {
    if (window.$pageCount) {
      this.$router.back(-1);
    } else {
      this.$router.push({
        name: 'HomeView'
      });
    }
  },
  cookie: {
    set: function (key, value, day) {
      var Days = day || 3;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = key + '=' + escape(value + '') + ';expires=' + exp.toGMTString() + ';path=/';
      // document.cookie = key + "="+ escape(value+'') + ";domain=.sd235.net;expires=" + exp.toGMTString()+";path=/";
    },
    get: function (key) {
      var arr,
        reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');

      if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    delete: function (key) {
      if (!key) {
        util.cookie.deleteAll();
        return;
      }
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.get(key);
      if (cval != null) {
        document.cookie = key + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/';
        // document.cookie= key + "="+cval+";domain=.sd235.net;expires="+exp.toGMTString()+";path=/";
      }
    },
    //删除cookie中所有定变量函数
    deleteAll() {
      var myDate = new Date();
      myDate.setTime(-1000); //设置时间
      var data = document.cookie;
      var dataArray = data.split('; ');
      for (var i = 0; i < dataArray.length; i++) {
        var varName = dataArray[i].split('=');
        document.cookie = varName[0] + "='';expires=" + myDate.toGMTString() + ';path=/';
        // document.cookie=varName[0]+"='';domain=.sd235.net;expires="+myDate.toGMTString()+";path=/";
      }
    }
  },
  // 拷贝对象
  copy: function (obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  // 对象转url参数
  parseURLParam: function (param) {
    let _res = parse(param);
    function parse(param, prefix) {
      let res = res || '';
      prefix = prefix || '';
      for (let key in param) {
        let d = param[key];
        switch (typeof d) {
          // 字符串
          case 'string':
            {
              if (prefix) {
                res += prefix + '[' + key + ']' + '=' + d + '&';
              } else {
                res += key + '=' + d + '&';
              }
            }
            break;
          // 数组、字典
          case 'object':
            {
              if (d.length != undefined) {
                for (let i in d) {
                  let _d = d[i];
                  if (prefix) {
                    res += prefix + '[' + key + ']' + '[]=' + _d + '&';
                  } else {
                    res += key + '[]=' + _d + '&';
                  }
                }
              } else {
                res += parse(d, key);
              }
            }
            break;
          default:
            {
              if (prefix) {
                res += prefix + '[' + key + ']' + '=' + d + '&';
              } else {
                res += key + '=' + d + '&';
              }
            }
            break;
        }
      }
      return res;
    }
    return _res ? _res.substr(0, _res.length - 1) : '';
  },
  // 过滤空键值
  removeEmpty: function (param) {
    if (param) {
      for (var k in param) {
        if (param[k] === '') {
          delete param[k];
        }
        for (var j in param[k]) {
          if (param[k][j] === '') {
            delete param[k][j];
          }
        }
      }
    }
    return param;
  },
  kAjax: function (url, _param, success, error, noAlert) {
    // 拷贝并过滤
    let param = JSON.parse(JSON.stringify(_param));
    param = util.removeEmpty(param);
    if (!url) {
      console.warn('kAjax : 参数 url 未定义！');
      return;
    }
    // 尾巴
    window.requestCount = window.requestCount || 1;
    request
      .post(url)
      .withCredentials()
      //  .use(jsonp({
      // timeout: 10000,
      // callbackName: 'callback' + window.requestCount++,
      // }))
      .type('form')
      .send(this.parseURLParam(param))
      .end(function (err, res) {
        if (err) {
          console.warn('请求错误 - ', url, param);
          return;
        }
        let json = JSON.parse(res.text);
        // var json = res.body;
        if (json.status == 4) {
          error && error();
          // 未登陆，跳转值登录页面
          auth.pop_login();
          return;
        }
        if (json.status == 1) {
          success && success(json);
        } else {
          error && error(json.message);
          !noAlert && util.confirm.error(json.message);
          console.warn('error:', json.message);
        }
      });
  },

  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 收藏相关 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
  // 获取收藏cookie
  getCollectCookie() {
    // 获取收藏相关cookie
    window.collectMap = {
      1: getIds(util.cookie.get('COLLECT_DUBBER_IDS')),
      2: getIds(util.cookie.get('COLLECT_VOICE_IDS')),
      3: getIds(util.cookie.get('COLLECT_ALBUM_IDS'))
    };
    function getIds(src) {
      if (!src) {
        return [];
      } else {
        return src.split(',');
      }
    }
  },
  /**
   * 储存收藏cookie
   * - 传入空值即清空
   */
  setCollectCookie(collectMap) {
    // 清空
    if (!collectMap) {
      util.cookie.delete('COLLECT_DUBBER_IDS');
      util.cookie.delete('COLLECT_VOICE_IDS');
      util.cookie.delete('COLLECT_ALBUM_IDS');
      return;
    }
    util.cookie.set('COLLECT_DUBBER_IDS', collectMap['1'].join(','));
    util.cookie.set('COLLECT_VOICE_IDS', collectMap['2'].join(','));
    util.cookie.set('COLLECT_ALBUM_IDS', collectMap['3'].join(','));
  },
  updateCollectCookie(typeId, _id, act) {
    // 区分单个和批量
    _id = typeof _id != 'object' ? [_id] : _id;
    _id.forEach((id) => {
      if (act == 'remove') {
        let index = window.collectMap[typeId].indexOf(id + '');
        if (index > -1) {
          window.collectMap[typeId].splice(index, 1);
        }
      } else {
        window.collectMap[typeId].push(id);
      }
    });
    util.setCollectCookie(window.collectMap);
  },
  // 转为表格
  toCSV(jsonData, titles, name) {
    var json = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;
    var CSV = '';
    /** title */
    if (titles) {
      var row = '';
      for (var i in titles) {
        row += titles[i] + ',';
      }
      row = row.slice(0, -1);
      CSV += row + '\n';
      // CSV += row + escape('\r\n');
    }
    /** data */
    for (var i in json) {
      var row = '';
      var r = json[i];
      for (var j in r) {
        row += '"' + (!isNaN(r[j]) && (r[j] + '').length > 12 ? "'" : '') + r[j] + '",';
      }
      row = row.slice(0, -1);
      CSV += row + '\n';
      // CSV += row + escape('\r\n');
    }
    CSV = CSV.replace(/\undefined/g, '-');
    if (CSV == '') {
      util.confirm.error('操作错误', '导出失败,表格内容不正确！');
      return;
    }
    var fileName = '';
    fileName += name.replace(/ /g, '_');
    CSV = encodeURIComponent(CSV);
    var uri = 'data:text/csv;charset=utf-8,\ufeff' + CSV;
    var link = document.createElement('a');
    $(link).attr('href', uri).css('visibility', 'hidden').attr('download', fileName);
    // link.style = "visibility:hidden";
    // link.download = fileName + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  // // 执行收藏
  // doCollect(typeId, arg){

  // 	let id = '',
  // 		type = {'1':'dubber','2':'voice','3':'album'}[typeId],
  // 		dom  = '',
  // 		param = {};
  // 	// id
  // 	if(typeof arg == 'object'){
  // 		dom = $(arg);
  // 		id = dom.attr('collect-'+type);
  // 	} else {
  // 		id = arg;
  // 		dom = $('[collect-'+type+'='+id+']')
  // 	}

  // 	// 取消收藏
  // 	if(dom.hasClass('on')){
  // 		param = { collectType:typeId, collectionIds:id };

  // 		util.kAjax(util.api('CUSTOMERCANCELCOLLECTION'), param, json => {
  // 			dom.removeClass('on');
  // 			util.updateCollectCookie(typeId,id,'remove');
  // 		})
  // 	// 增加收藏
  // 	} else {
  // 		param = { collectType:typeId, collectionId:id };
  // 		util.kAjax(util.api('CUSTOMERCOLLECT'), param, json => {
  // 			dom.addClass('on');
  // 			util.updateCollectCookie(typeId,id);
  // 		})
  // 	}
  // },
  /**
   * 加入收藏
   */
  // collectIn(type, id){
  // let id = '',
  // 	type = {'1':'dubber','2':'voice','3':'album'}[typeId],
  // 	dom  = '',
  // 	param = {};
  // // id
  // if(typeof arg == 'object'){
  // 	dom = $(arg);
  // 	id = dom.attr('collect-'+type);
  // } else {
  // 	id = arg;
  // 	dom = $('[collect-'+type+'='+id+']')
  // }
  // param = { collectType:typeId, collectionId:id };
  // return;
  // util.kAjax(util.api('CUSTOMERCOLLECT'), param, json => {
  // 	// 更新视图
  // 	dom.addClass('on');
  // })
  // },
  /**
   * 取消收藏
   */
  // collectOut(type, id){
  // let id = '',
  // 	type = {'1':'dubber','2':'voice','3':'album'}[typeId],
  // 	dom  = '',
  // 	param = {};
  // // id
  // if(typeof arg == 'object'){
  // 	dom = $(arg);
  // 	id = dom.attr('collect-'+type);
  // } else {
  // 	id = arg;
  // 	dom = $('[collect-'+type+'='+id+']')
  // }
  // param = { collectType:typeId, collectionId:id };
  // return;
  // util.kAjax(util.api('CUSTOMERCOLLECT'), param, json => {
  // 	// 更新视图
  // 	dom.addClass('on');
  // })
  // },
  // 绑定收藏
  bind_collect() {
    util.getCollectCookie();
    $('body').on('click', '[collect-dubber]', function (e) {
      util.doCollect(1, this);
    });
    $('body').on('click', '[collect-voice]', function (e) {
      util.doCollect(2, this);
    });
    $('body').on('click', '[collect-album]', function (e) {
      util.doCollect(3, this);
    });
  },
  /* <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 收藏相关 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

  /**
   * common methoed
   */
  jumpDetail(type, id) {
    if (!id) {
      return;
    }
    let name = '';
    if (type == 'dubber') {
      name = 'DetailDubberView';
    } else {
      name = 'DetailVoiceView';
    }
    this.$router.push({
      name: name,
      params: { id: id }
    });
  },
  /**
   * 缓存声音数据
   */
  addSoundData(datas) {
    let data = {};
    datas.forEach((d) => {
      // 试音
      if (!d.voiceId) {
        data[d.id] = {
          id: d.id,
          // audio: 'http://d.sd235.net/'+d.auditionServerPath,
          audio: 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + d.auditionServerPath,
          img: '',
          dubbingName: d.auditionDubboNum,
          dubbingId: d.auditionDubboId,
          title: d.auditionName
        };
      } else {
        // 发布的声音
        data[d.voiceId] = {
          id: d.voiceId,
          audio: d.filePath,
          img: d.deployDubbing ? d.deployDubbing.dubbingHead : '',
          dubbingName: d.nameExternal,
          dubbingId: d.dubbingId,
          title: d.voiceTitle
        };
      }
    });
    gPlayer.soundData = {
      ...gPlayer.soundData,
      ...data
    };
  },
  // 退出
  logout: function () {
    util.cookie.delete('userName');
    // 清空收藏
    util.setCollectCookie();
    util.kAjax(util.api('LOGINOUT'), {});
    setTimeout(function () {
      location.reload(true);
    });
  },
  // IM在线客服块
  popIM: function () {
    // <li><a data-base-id="6027" target="_blank" href="/sdchat.html?baseId=6027&userPetname=小会">小会</a></li>
    //    <li><a data-base-id="3326" target="_blank" href="/sdchat.html?baseId=3326&userPetname=丽">丽</a></li>
    //    <li><a data-base-id="2889" target="_blank" href="/sdchat.html?baseId=2889&userPetname=小梁">小梁</a></li>
    //    <li><a data-base-id="4110" target="_blank" href="/sdchat.html?baseId=4110&userPetname=小文">小文</a></li>
    //    <li><a data-base-id="6006" target="_blank" href="/sdchat.html?baseId=6006&userPetname=小张">小张</a></li>
    var list = `<li><a data-base-id="1" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=1&userPetname=深度7号">深度7号</a></li>
				   <li><a data-base-id="2" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=2&userPetname=深度8号">深度8号</a></li>
				   <li><a data-base-id="3" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=3&userPetname=深度2号">深度2号</a></li>
				    <li><a data-base-id="4" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=4&userPetname=深度5号">深度5号</a></li>
				   <li><a data-base-id="5" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=4110&userPetname=深度3号">深度3号</a></li>
				   <li><a data-base-id="6" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=11612&userPetname=深度26号">深度26号</a></li>
				   <li><a data-base-id="7" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=6138&userPetname=深度18号">深度18号</a></li>
				   <li><a data-base-id="8" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=3746&userPetname=深度10号">深度10号</a></li>
				   <li><a data-base-id="9" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=11613&userPetname=深度27号">深度27号</a></li>
				
				`;

    var dom = $(list);
    setInterval(update, 550000);
    update();
    function update() {
      util.kAjax(util.api('ONLINEWAITERLIST'), {}, function (json) {
        var data = json.data || [];
        dom.find('[data-base-id]').removeClass('online');
        $.each(data, function (i, d) {
          var t = dom.find('[data-base-id=' + d.baseId + ']');
          t.addClass('online');
        });
      });
    }

    // 更新IM在线客服
    $('body').on('mouseenter', '.kf_btn', function () {
      var wrap = $(this).find('ul');
      wrap.replace(dom);
    });
    // 跳转前检测登录状态
    $('body').on('click', '[data-im-href]', function () {
      var $this = $(this),
        href = $this.attr('data-im-href'),
        win = window.open();
      win.location.href = href;
    });
  },
  /**
   * 挂载公共触发方法
   */
  publicEvent: function () {
    // 在线客服配置
    util.popIM();
  }
};
// 挂载公告响应方法
util.publicEvent();
window.util = util;
export { util };



// WEBPACK FOOTER //
// ./src/service/util.js